import { put } from 'redux-saga/effects';
import EasyRedux from '../../utils/EasyRedux';
import handleSagaError from '../handleSagaError';
import history from '../../utils/history';
import { actions as profileActions } from './profile';

const key = 'SESSION/SWITCHBUSINESS';

export const { actionTypes, actions, reducer } = new EasyRedux(key);

export function* watchSwitchBusiness(client, { payload }) {
  try {
    const response = yield client.post('/session/switchBusiness', {
      data: { bi: payload.bi },
    });
    yield put(actions.loadSuccess(response.result));
    yield put(profileActions.load());
    window.location.href = '/';
    // history.push('/');
  } catch (e) {
    yield put(actions.loadFailure(e));
    yield handleSagaError(e);
  }
}

export default reducer;
